import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'sonner';
export function Workshops() {
  const [filter, setFilter] = useState('All');
  const filters = ['All', 'Cooking', 'Cultural', 'Professional'];
  const workshops = [{
    id: 0,
    category: ['Cooking', 'Cultural'],
    date: 'Thu August 20',
    time: '6–8 PM',
    title: 'Que with a View',
    instructor: 'Chef D\u2019Mac',
    blurb: 'Chef D\u2019Mac of D\u2019Mac\u2019s BBQ shares two decades of real backyard experience — techniques, seasoning philosophy, and smoking methods. Come hungry. Leave smoking like you mean it.',
    price: 'Free'
  }, {
    id: 1,
    category: ['Professional'],
    date: 'Registration Open',
    time: 'Full-Day Course & Exam',
    title: 'Food Protection Manager Certification',
    instructor: 'Certified Instructor',
    blurb: 'Earn your accredited Food Protection Manager Certification. This course covers safe food handling, storage, and preparation, and includes the certification exam — ideal for vendors, chefs, and food entrepreneurs.',
    price: 'Paid',
    cta: 'Register on Eventbrite',
    link: 'https://www.eventbrite.com/e/food-protection-manager-certification-course-exam-tickets-1989602570848?aff=oddtdtcreator'
  }];
  const filteredWorkshops = filter === 'All' ? workshops : workshops.filter(w => w.category.includes(filter));
  const handleReserve = () => {
    toast.success('Spot reserved! Check your email for details.');
  };
  return <section id="workshops" className="py-20 lg:py-32 bg-foodCard border-y-4 border-foodMaroon relative overflow-hidden" data-id="element-277" data-mp="2urbbx1jgh4l6">
      {/* Decorative background element */}
      <div className="absolute -right-20 top-20 w-64 h-64 bg-foodCream rounded-full border-4 border-foodMaroon opacity-50 pointer-events-none" data-id="element-278" data-mp="33rrbw10zptla"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-279" data-mp="38rm1m1914d4r">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-280" data-mp="18ntaylwizxji">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="max-w-2xl" data-id="element-281" data-mp="13q03lpjhkxhn">
            <h2 className="text-5xl md:text-6xl font-extrabold uppercase mb-4" data-id="element-282" data-mp="1reazeeabs6z2">
              August Workshops & <span className="text-foodGold" data-id="element-283" data-mp="1ne8vdyh4b1gm">Classes</span>
            </h2>
            <p className="text-xl font-medium" data-id="element-284" data-mp="21d05zawru500">
              Roll up your sleeves this August. Every workshop is a free community
              experience — learn new skills, connect with neighbors, and eat
              what you make.
            </p>
          </motion.div>

          {/* Filters */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-wrap gap-2" data-id="element-285" data-mp="20e8uw5j58e4">
            {filters.map(f => <button key={f} onClick={() => setFilter(f)} className={`px-4 py-2 font-bold border-2 border-foodMaroon transition-all ${filter === f ? 'bg-foodMaroon text-foodCream shadow-[2px_2px_0px_0px_#E25822]' : 'bg-foodCream text-foodMaroon hover:bg-foodGold hover:shadow-[2px_2px_0px_0px_#3D1610]'}`} data-id="element-286" data-mp="23xep5h4zdcux">
                {f}
              </button>)}
          </motion.div>
        </div>

        {/* Grid */}
        <motion.div layout className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-287" data-mp="1pyoue85mvp9q">
          <AnimatePresence data-id="element-288" data-mp="3fdwmrkkbdlj5">
            {filteredWorkshops.map(workshop => <motion.div layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.3
          }} key={workshop.id} className="bg-foodCream border-4 border-foodMaroon p-6 flex flex-col h-full hover:-translate-y-2 hover:border-foodOrange hover:shadow-[8px_8px_0px_0px_#3D1610] transition-all duration-300 group" data-id="element-289" data-mp="3kcg8bjuzwvaz">
                <div className="flex justify-between items-start mb-4" data-id="element-290" data-mp="shprb73ll77f">
                  <div className="flex flex-col gap-1" data-id="element-291" data-mp="njej10syb4rb">
                    <span className="bg-foodOrange text-white font-bold px-3 py-1 text-sm border-2 border-foodMaroon rotate-[-2deg] w-fit" data-id="element-292" data-mp="nkzbmkvpgdmj">
                      {workshop.date}
                    </span>
                    <span className="text-foodMaroon/60 font-bold text-xs uppercase tracking-wider pl-1" data-id="element-293" data-mp="dlrwpt9boaxb">
                      {workshop.time}
                    </span>
                  </div>
                  <span className="font-display font-bold text-xl text-foodTomato uppercase" data-id="element-294" data-mp="8etlie2tumvp">
                    {workshop.price}
                  </span>
                </div>

                <h3 className="text-2xl font-extrabold uppercase mb-2 group-hover:text-foodOrange transition-colors" data-id="element-295" data-mp="idj2m4mwg3aw">
                  {workshop.title}
                </h3>
                <p className="text-foodMaroon/60 font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-296" data-mp="3lv17q4baew7m">
                  with {workshop.instructor}
                </p>
                <p className="mb-8 flex-grow font-medium" data-id="element-297" data-mp="3qsavzgmxx1tv">{workshop.blurb}</p>

                {workshop.link ? <a href={workshop.link} target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-transparent border-4 border-foodMaroon text-foodMaroon font-bold py-3 hover:bg-foodMaroon hover:text-foodCream transition-colors mt-auto" data-id="element-298" data-mp="2y5q5sji7avrw">
                    {workshop.cta || 'Reserve Free Spot'}
                  </a> : <button onClick={handleReserve} className="w-full bg-transparent border-4 border-foodMaroon text-foodMaroon font-bold py-3 hover:bg-foodMaroon hover:text-foodCream transition-colors mt-auto" data-id="element-299" data-mp="34tdnfnjnigyf">
                    {workshop.cta || 'Reserve Free Spot'}
                  </button>}
              </motion.div>)}
          </AnimatePresence>
        </motion.div>

        {filteredWorkshops.length === 0 && <div className="text-center py-20" data-id="element-300" data-mp="2h314lhmvazt2">
            <p className="text-2xl font-bold text-foodMaroon/50" data-id="element-301" data-mp="1cy81sgunkg1">
              No workshops found for this category.
            </p>
          </div>}
      </div>
    </section>;
}